import { useQuery } from '@tanstack/react-query';
import { useUser } from '@clerk/clerk-react';
import { apiClient, type TrialStatus } from '../services/api-client';

export function useTrialStatus(): TrialStatus | null {
  const { isSignedIn, user } = useUser();

  const { data } = useQuery({
    queryKey: ['trialStatus', user?.id ?? null], // scoped per user — prevents cross-user cache bleed
    queryFn: () => apiClient.getTrialStatus(),
    enabled: isSignedIn === true,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    retry: false,
  });

  return data ?? null;
}
